import { render, staticRenderFns } from "./conexao-actions-menu.vue?vue&type=template&id=51fedb56&scoped=true&"
import script from "./conexao-actions-menu.vue?vue&type=script&lang=js&"
export * from "./conexao-actions-menu.vue?vue&type=script&lang=js&"
import style0 from "./conexao-actions-menu.vue?vue&type=style&index=0&id=51fedb56&lang=sass&scoped=true&"
import style1 from "./conexao-actions-menu.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fedb56",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VProgressCircular,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51fedb56')) {
      api.createRecord('51fedb56', component.options)
    } else {
      api.reload('51fedb56', component.options)
    }
    module.hot.accept("./conexao-actions-menu.vue?vue&type=template&id=51fedb56&scoped=true&", function () {
      api.rerender('51fedb56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/conexao-actions-menu/conexao-actions-menu.vue"
export default component.exports